<template>
  <div v-if="!!phaseData">
    <div>
      <field-label
        titleClass="text-h6"
        titleColorClass="grey--text text--darken-2"
        label="Marque as áreas afetadas"
        class="mt-4"
      >
        <div class="d-flex" :class="{ 'flex-column': $vuetify.breakpoint.smAndDown }">
          <div
            class="d-flex flex-column align-center"
            :style="{
              'flex-basis': $vuetify.breakpoint.smAndDown ? 'auto' : '10%',
              order: $vuetify.breakpoint.smAndDown ? 3 : 'auto',
            }"
          >
            <div class="select-area" @click="shownModel = 'body'" :class="{ active: shownModel === 'body' }">
              <psoriasis-body-model
                v-model="phaseData['areas_afetadas']"
                height="120px"
                class="mt-4 d-flex justify-center"
                width="100%"
                readOnly
                :showBack="showBack"
              />
            </div>
            <div class="select-area" @click="shownModel = 'hand'" :class="{ active: shownModel === 'hand' }">
              <psoriasis-hand-model
                v-model="phaseData['areas_afetadas']"
                :height="120"
                class="mt-4 d-flex justify-center"
                readOnly
                :showBack="showBack"
              />
            </div>
            <div class="select-area" @click="shownModel = 'foot'" :class="{ active: shownModel === 'foot' }">
              <psoriasis-foot-model
                v-model="phaseData['areas_afetadas']"
                :height="120"
                class="mt-4 d-flex justify-center"
                readOnly
              />
            </div>
          </div>
          <div
            class="d-flex flex-column align-center"
            :style="{
              'flex-basis': $vuetify.breakpoint.smAndDown ? 'auto' : '50%',
              order: $vuetify.breakpoint.smAndDown ? 4 : 'auto',
            }"
          >
            <v-btn id="btn-show-back" depressed class="text-none" color="#E0F0FF" @click="showBack = !showBack" style="width: 60%">
              <v-icon color="#1976D2">mdi-rotate-360</v-icon>
              Virar
            </v-btn>
            <psoriasis-body-model
              v-model="phaseData['areas_afetadas']"
              height="600px"
              class="mt-4 d-flex justify-center"
              style="flex-basis: 50%"
              width="100%"
              :showBack="showBack"
              v-if="shownModel === 'body'"
              :style="{
              order: $vuetify.breakpoint.smAndDown ? 4 : 'auto',
            }"
            />
            <psoriasis-hand-model
              v-model="phaseData['areas_afetadas']"
              :height="600"
              class="mt-4 d-flex justify-center"
              style="flex-basis: 50%"
              :showBack="showBack"
              v-if="shownModel === 'hand'"
              :style="{
              order: $vuetify.breakpoint.smAndDown ? 4 : 'auto',
            }"
            />
            <psoriasis-foot-model
              v-model="phaseData['areas_afetadas']"
              :height="600"
              class="mt-4 d-flex justify-center"
              style="flex-basis: 50%"
              :showBack="showBack"
              v-if="shownModel === 'foot'"
              :style="{
              order: $vuetify.breakpoint.smAndDown ? 4 : 'auto',
            }"
            />
          </div>
          <v-divider
            :vertical="$vuetify.breakpoint.mdAndUp"
            :class="{
              'ml-auto': $vuetify.breakpoint.mdAndUp,
              'my-4': $vuetify.breakpoint.smAndDown,
            }"
            :style="{
              order: $vuetify.breakpoint.smAndDown ? 2 : 'auto',
            }"
          />
          <div
            class="d-flex flex-column"
            :class="{ 'pl-12': $vuetify.breakpoint.mdAndUp }"
            :style="{
              'flex-basis': $vuetify.breakpoint.smAndDown ? 'auto' : '50%',
              order: $vuetify.breakpoint.smAndDown ? 1 : 'auto',
            }"
          >
            <span class="font-weight-bold text-h6 mb-2">Áreas afetadas</span>

            <span v-if="affectedAreas.length === 0">Sem lesões</span>
            <div v-for="areaClass in affectedAreasClass" :key="areaClass" class="d-flex flex-column my-2">
              <span class="font-weight-bold"> {{ areaClass }}</span>
              <span
                v-for="area in affectedAreas.filter((a) => a.classKey === areaClass)"
                :key="area.key"
                class="d-flex flex-column mt-1"
              >
                {{ area.label }}</span
              >
            </div>
          </div>
        </div>
      </field-label>

      <attendance-step-note class="mt-8 py-2" />
    </div>
  </div>
</template>

<script>
import FieldLabel from '@/components/FieldLabel.vue'
import BasePhase from '@/components/AttendanceForm/general/phase/BasePhase.vue'
import PsoriasisHandModel from '@/components/AttendanceForm/psoriasis/PsoriasisHandModel.vue'
import PsoriasisFootModel from '@/components/AttendanceForm/psoriasis/PsoriasisFootModel.vue'
import PsoriasisBodyModel from '@/components/AttendanceForm/psoriasis/PsoriasisBodyModel.vue'
import AttendanceStepNote from '@/components/AttendanceForm/psoriasis/phase/v2/AttendanceStepNote.vue'

export default {
  extends: BasePhase,
  components: {
    AttendanceStepNote,
    FieldLabel,
    PsoriasisBodyModel,
    PsoriasisHandModel,
    PsoriasisFootModel,
  },
  data() {
    return {
      showBack: false,
      shownModel: 'body',
      medicineOptions: [
        { text: 'Sim, teve melhoria', value: 'SIM_COM_MELHORIA' },
        { text: 'Sim, mas não teve melhoria', value: 'SIM_SEM_MELHORIA' },
        { text: 'Não usou ainda', value: 'NAO' },
      ],
    }
  },
  computed: {
    affectedAreas() {
      return Object.values(this.phaseData['areas_afetadas']).filter((a) => a.selected)
    },
    affectedAreasClass() {
      return [...new Set(Object.values(this.affectedAreas).map((a) => a.classKey))]
    },
  },
  methods: {
    getDefaultData() {
      const data = {
        medicamentos_previos_mais_de_3_meses: null,
        areas_afetadas: {},
        notes: null,
      }
      return data
    },
  },
}
</script>

<style scoped>
.big-number--negative {
  color: red;
  font-weight: medium;
  font-size: 1.5rem;
}

.select-area {
  border: 2px solid lightgray;
  padding-bottom: 10px;
  width: 100%;
  margin-bottom: 12px;
  cursor: pointer;
}

.select-area.active {
  border: 2px solid #1976d2;
}
</style>
